export const NO_EMPTY_NO_EMPTY_SPACES = /^\s*$/;
export const SESSION_MEET_VALID_URL =
  // eslint-disable-next-line
  /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/;
export const VALID_GRADE = '^[0-9]*$';
export const VALID_PAYROLL_NUMBER = '^[0-9]{1,8}$';

export default {
  NO_EMPTY_NO_EMPTY_SPACES,
  SESSION_MEET_VALID_URL,
  VALID_GRADE,
  VALID_PAYROLL_NUMBER,
};
